export default __webpack_public_path__ + "85505234008629d90818e0ae13afce6c.svg";